import React, { useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import PageHeader from "@bytenite/components/src/components/layoutComponents/PageHeader";
import HubspotForm from "react-hubspot-form";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { Box } from "@mui/material";

import { useEffect } from "react";
const Support = (props) => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  return (
    <>
      <PageHeader title={"Support"}></PageHeader>
      <HubspotForm
        region="na1"
        portalId="22562360"
        formId="e78592b2-d5b6-4d12-a611-bd8fd33ce4f0"
        onSubmit={() => setFormSubmitted(true)}
        onReady={(form) => console.log("Form ready")}
        loading={
          <div>
            <Typography variant="h6" color="textSecondary">
              Loading...
            </Typography>
          </div>
        }
      />
    </>
  );
};

export default Support;
